<template>
  <div>
    <div class="selected_lotto_list" v-if="winnerOpen == 'Y'">
      <div class="text">
        <span>당첨번호</span>
        <span>보너스</span>
      </div>
      <div class="list_wrap">
        <div class="selected_ball_list">
          <div class="num_ball" v-for="(lotto, idx) in selectedList" :key="idx" :style="`background:${lotto.color}`">{{ lotto.num }}</div>
        </div>
        <div class="num_ball bonus" style="background :#FBC400">{{ bonus }}</div>
      </div>
    </div>
    <table class="event_rank" v-if="winnerOpen == 'Y'">
      <thead>
        <tr>
          <td>
            <p>순위</p>
          </td>
          <td>
            <p>닉네임(폰번호)</p>
            <p>참여시간</p>
          </td>
         <td>
          <p>추천번호</p>
          <p>당첨갯수</p>
        </td>
      </tr>
      </thead>
      <tbody>
        <winner-list-table-form v-for="(winner, idx) in winnerList" :key="idx" :winner="winner" :lottoList="lottoList"></winner-list-table-form>
      </tbody>
      <tfoot>
        <tr v-if="addressInputYn == 'Y'">
          <td colspan="3" class="event_btn" @click="openAddressPop">
            <div class="apply btn submit" id="modal-open">
              <a>이벤트 상품 수령 주소입력</a>
            </div>
          </td>
        </tr>
        <tr class="winner_text">
          <td colspan="3">
            <div class="winner_list" v-if="winnerOpen == 'Y'" @click="goToWinnerList">당첨자 목록</div>
            <div v-if="winnerOpen == 'Y'" v-html="winnerText">
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
    <address-popup :open="open" ref="address"/>
  </div>
</template>

<script>
import WinnerListTableForm from './WinnerListTableForm.vue'
import AddressPopup from '@/components/common/AddressPopup.vue'
export default {
  components: {
    WinnerListTableForm,
    AddressPopup
  },
  created() {
  },
  data() {
    return {
      open: false
    }
  },
  props: {
    winnerList: {
      type: Array
    },
    selectedList: {
      type: Array
    },
    bonus: {
      type: Number
    },
    winnerOpen: {
      type: String
    },
    winnerText: {
      type: String
    },
    lottoList: {
      type: Array
    },
    addressInputYn: {
      type: String
    },
  },
  methods: {
    goToWinnerList() {
      this.$router.push({
        path: '/winnerList', query: {
          nttId: this.$route.query.nttId
        }
      })
    },
    openAddressPop() {
      this.$refs.address.modalOpen();
    }
  },

}
</script>

<style scoped>
.selected_lotto_list {
  background-color: #F2F3F6;
  width: 335px;
  height: 100px;
  margin: auto;
  border-radius: 8px;
  margin-top: 20px;
}

.num_ball {
  border-radius: 34px;
  width: 34px;
  background: #CDD2DA;
  display: inline-block;
  height: 34px;
  text-align: center;
  color: white;
  font-weight: bold;
  line-height: 34px;
  font-size: 12px;
  margin-right: 5px;
  margin-bottom: 9px;
}
.selected_lotto_list .list_wrap {
  bottom: 0;
  display: flex;
  justify-content: space-between;
  margin-left: 20px;
}

.selected_lotto_list .text {
  padding: 20px 20px 12px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #9EA3AB;
}

.list_wrap .bonus {
  margin-right: 20px;
}

table {
  width: 100%;
  margin-top: 15px;
}

table thead {
  border-top: 1px solid #CDD2DA;
  border-bottom: 1px solid #CDD2DA;
  color: #9EA3AB;
  font-size: 12px;
  height: 53px;
}

table thead tr td {
  padding-top: 12px;
}

table thead tr td:nth-child(2) {
  text-align: left;
}

table thead tr td:nth-child(3), table tbody tr td:nth-child(3) {
  text-align: right;
  padding-right: 14px;
}

table thead tr td:nth-child(1), table tbody tr td:nth-child(1){
  text-align: center;
  min-width: 40px;
}

table tbody tr{
  font-size: 12px;
  height: 60px;
}

table tbody tr td {
  padding-top: 14px;
  border-bottom: 1px solid #CDD2DA;
}

table tbody tr td span {
  color: #9EA3AB;
}

table tfoot .winner_text td div {
  padding: 30px;
  font-size: 14px;
}
.active {
  color: #FF7100;
}
.winner_list {
  text-align: center;
  text-decoration: underline;
}
.event_btn {
  padding: 0 10px;
}
</style>